// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quill-editor[data-v-3703a50b] {\n  overflow: hidden;\n  padding-bottom: 65px;\n}\n[data-v-3703a50b] .ql-toolbar.ql-snow {\n  border-color: #DFE3E5;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n[data-v-3703a50b] .ql-container.ql-snow {\n  border-color: #DFE3E5;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n[data-v-3703a50b] .ql-container.ql-snow .ql-editor {\n  min-height: 275px;\n}", ""]);
// Exports
module.exports = exports;
